<template>
  <v-app>
      <Header></Header>
    <v-main>
      <slot></slot>
    </v-main>
      <Footer></Footer>
  </v-app>
</template>
<script>
import Footer from '@/components/shared/footer/Footer';
import Header from '@/components/shared/header/Header';

export default {
  components: {
    Footer,
    Header,
  },
}
</script>